import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import { deepObjectsMerge } from "./../../../../utils/deepObjectsMerge";
import { sharedOptions } from "../sharedOptions";
import type { IChartInternalProps } from "./../../../../types/charts/chart/internal-props";
import type { IBarChart } from "./../../../../types/charts/chart/bar_chart";

export const BarChart = ({
  type = 'column',
  series,
  options,
  categories,
  ...internalProps
}: IBarChart) => {
  const { colors, labels } = (internalProps as IChartInternalProps);

  const modifiedSeries = series?.map((item, index: number) => ({ ...item, name: labels?.[index] }));

  const localOptions: ApexOptions = {
    grid: {
      padding: {
        top: -15,
      }
    },
    colors: colors,
    xaxis: {
      crosshairs: {
        show: false,
      },
    },
    chart: {
      type: "bar",
      stacked: true
    },
    stroke: {
      width: 0,
    },
    fill: {
      opacity: 1
    },
    dataLabels: {
      enabled: false,
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
      active: {
        filter: {
          type: 'none',
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: type === 'bar' ? true : false,
        borderRadius: 0,
        borderRadiusWhenStacked: 'last',
        borderRadiusApplication: 'end',
      }
    },
  };

  const mergedOptions = deepObjectsMerge(sharedOptions, localOptions, (options ?? {}));

  return (
    <Chart
      options={mergedOptions}
      series={modifiedSeries}
      type="bar"
      width="100%"
      height="100%"
    />
  )
}